import { Input, FormProps, Select } from 'antd';

import useInfiniteAPIQuery from '../api/useInfiniteAPIQuery';
import usePrefetchPages from '../hooks/usePrefetchPages';
import Form from './Form';

export interface UserFormValues {
  name?: string;
  username: string;
  email: string;
  groups?: number | number[];
}

export interface UserFormProps extends FormProps {
  isActive?: boolean;
  disableUsername?: boolean;
  disableIfAuth?: boolean;
}

const UserForm = ({ isActive, disableUsername, disableIfAuth, ...props }: UserFormProps) => {
  const groupsPages = useInfiniteAPIQuery([`/groups/`]);
  const groups = usePrefetchPages(groupsPages, (data) => data.results);

  return (
    <Form<UserFormValues> {...props}>
      <Form.Row>
        <Form.Col span={12}>
          <Form.Item label="Nome" name="name" rules={[{ required: true }]}>
            <Input disabled={isActive === false || disableIfAuth} />
          </Form.Item>
        </Form.Col>
        <Form.Col span={12}>
          <Form.Item label="Usuário" name="username" rules={[{ required: true }]}>
            <Input disabled={isActive === false || disableUsername || disableIfAuth} />
          </Form.Item>
        </Form.Col>
      </Form.Row>
      <Form.Row>
        <Form.Col span={12}>
          <Form.Item label="E-mail" name="email" rules={[{ required: true }]}>
            <Input disabled={isActive === false || disableIfAuth} />
          </Form.Item>
        </Form.Col>
        <Form.Col span={12}>
          <Form.Item label="Perfil de acesso" name="groups" rules={[{ required: true }]}>
            <Select showSearch optionFilterProp="children" disabled={isActive === false}>
              {groups.map((group) => (
                <Select.Option key={group.id} value={group.id}>
                  {group.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form.Col>
      </Form.Row>
    </Form>
  );
};

export default UserForm;
